import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ISelectOption } from '../../../../../../../../design/inputs/select/ISelectOption';
import { CheckboxMultiSelect } from '../../../../../../../components/CheckboxMultiSelect';
import { FilterContent } from '../FilterContent';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const CorrectedBody = observer((props: ImageFiltersFormProps): ReactElement => {
  const { t } = useTranslator();

  const handleSelectedChanged = (selected: ISelectOption<boolean>[]): void => {
    props.onSetCorrected(selected.map((x) => x.value));
  };

  const options: ISelectOption<boolean>[] = [
    { label: t('yes'), value: true },
    { label: t('no'), value: false },
  ];

  const selectedOptions = options.filter((o) => props.imageFilters.corrected.includes(o.value));

  return (
    <FilterContent>
      <CheckboxMultiSelect<ISelectOption<boolean>>
        options={options}
        values={selectedOptions}
        labelField='label'
        valueField='value'
        onSelectChange={handleSelectedChanged}
      />
    </FilterContent>
  );
});
